import $ from 'jquery';

$(document).ready(function() {
    $('.js-info table').wrapAll('<div class="table-wrapper" />');
});